import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { Apis } from "../../config";
import apiService from "../../services/ApiService";

const fetchReuseProduct = createAsyncThunk('products/fetchReuseProducts', async (data, { rejectWithValue }) => {
    try {
        let response = await apiService.post(`${Apis.GetGlobalReuseProducts}?page=${data?.page}&size=${data?.size}`, data);
        return response;
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch products');
    }
});

const fetchMoreReuseProducts = createAsyncThunk('products/fetchMoreReuseProducts', async (data, { rejectWithValue }) => {
    try {
        let response = await apiService.post(`${Apis.GetGlobalReuseProducts}?page=${data?.page}&size=${data?.size}`, data);;
        return response;
    } catch (err) {
        return rejectWithValue(err?.message || 'Failed to fetch more products');
    }
});


export const reuseProductThunks = { fetchReuseProduct,  fetchMoreReuseProducts};

